export type Data = unknown &
  { fromDate: Date | string; toDate?: Date | string }[];

export const getToDates = (data: any) => {
  const mapped = data
    .sort(
      (a: any, b: any) =>
        new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime()
    )
    .reduce((acc: any[], cur: any, i: number) => {
      if (i !== 0) {
        cur.toDate = acc[i - 1].fromDate;
      } else {
        cur.toDate = undefined;
      }
      acc.push(cur);

      return acc;
    }, []);

  return mapped;
};
